var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.Service}},[_c('TableText',{attrs:{"prop":"id","label":"ID","width":100}}),_c('TableImage',{attrs:{"prop":"image","label":"图片"}}),_c('TableText',{attrs:{"prop":"url","label":"链接地址","width":260}}),_c('TableOptions',{attrs:{"prop":"position","label":"位置","width":100}}),_c('TableText',{attrs:{"prop":"sort","label":"顺序","width":100}}),_c('TableAction',{attrs:{"buttons":[
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }